
import React from 'react';
import FA from 'react-fontawesome';

import NextSectionButton from '../common/NextSectionButton';
import ContactFormContainer from './ContactFormContainer';

import app from '../../app_data/index';

import './index.css';

const Contact = () => (
  <div id="contact">
    <h3 className="classBecauseCannotIsolateFromPanelH3">
      <NextSectionButton
        targetID="brand"
        title="Back to top"
      >
        <FA name={app.mainIcon} />
      </NextSectionButton>

      {' '}Contact{' '}

      <NextSectionButton
        targetID="projects"
        angleIcon="up"
        title="Projects"
      />
    </h3>

    <h4 className="subtitle">
      Send me an <a href={ `mailto:${app.contact.email}` } >email</a>
      {' '}or use the form below.
    </h4>

    <hr />

    <ContactFormContainer />
  </div>
);

export default Contact;



// WEBPACK FOOTER //
// ./src/components/contact/index.js